import {fetchSuperUsers} from './thunks';
import createGenericSlice from '../createGenericSlice';
import {slicesNames} from '../constants';

export const superUsersSlice = createGenericSlice({
    name: slicesNames.superUsers,
    initialState: {
        data: {
            result: [],
            page: {
                from: 0,
                size: 20,
                total: 0,
            },
        },
        statuses: {},
        errors: {},
        lastRequestId: {},
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchSuperUsers.fulfilled, (state, {payload}) => {
            if (payload) state.data = payload;
        });
    },
});

export const {resetSlice} = superUsersSlice.actions;
